import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import { Badge, Box, Stack, ToggleButton, ToggleButtonGroup, Toolbar, Typography, useTheme } from '@mui/material';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import _ from 'lodash';
import React, { useContext, useState } from "react";
import { Drawer } from '../common/drawer';
import { SessionDataContext } from '../contexts';
import CourseAutocomplete from '../course/course.autocomplete';
import StudentAutocomplete from '../student/student.autocomplete';
import SubjectAutocomplete from '../subject/subject.autocomplete';
import TodoList from '../todo/todo.list';
import { useAppStore } from './store';
import TermAutocomplete from '../term/term.autocomplete';

export default function MenuRight(props) {
	const {todos} = useAppStore();
	const theme = useTheme();
	const sessionData = useContext(SessionDataContext);

	const [open, setOpen] = useState(sessionData.drawerOpen);
	const [selected, setSelected] = useState(sessionData.drawerSelected);

	const toggleDrawer = () => {
		setOpen(!open);
		props?.onToggle?.(!open);
		sessionData.set('drawerOpen', !open);

		if (open) {
			selectDrawerItem(null);
		}
	};

	const selectDrawerItem = (drawerItem) => {
		if (!open) {
			toggleDrawer();
		}

		// drawerItem = drawerItem != selected ? drawerItem : null;
		setSelected(drawerItem);
		sessionData.set('drawerSelected', drawerItem);
	};

	const listItemSx = { display: 'block' };
	const listItemButtonSx = open ? { justifyContent: 'initial' } : { justifyContent: 'center' };
	const listItemIconSx = [{ minWidth: 16, justifyContent: 'center' }, open ? { mr: 2 } : { mr: 'auto' }];
	const openSx = open ? { opacity: 1 } : { opacity: 0 };
	const selectedItem = theme.palette.mode == 'dark' ? { backgroundColor: 'rgba(255, 255, 255, 0.16)' } : { backgroundColor: 'rgba(0, 0, 0, 0.08)' };
	const stackSx = { justifyContent: 'space-between', alignItems: 'center' };
	const filterCount = sessionData.filterStudentIds?.length + sessionData.filterSubjectIds?.length + sessionData.filterCourseIds?.length;

	return (
		<Drawer anchor="right" variant="permanent" open={open} sx={{ display: 'flex', flexDirection: 'column' }}>
			<Toolbar />
			<List sx={{ py: 0, flex: 1, display: 'flex', flexDirection: 'column' }}>
				<ListItem disablePadding sx={listItemSx}>
					<ListItemButton sx={listItemButtonSx} onClick={toggleDrawer}>
						<ListItemIcon sx={listItemIconSx}>
							{open ? <ChevronRightIcon sx={{ stroke: theme.palette.text.secondary, strokeWidth: 3 }} /> : <ChevronLeftIcon sx={{ stroke: theme.palette.text.secondary, strokeWidth: 3 }} />}
						</ListItemIcon>
					</ListItemButton>
				</ListItem>
				<Divider />
				<ListItem disablePadding sx={listItemSx}>
					<ListItemButton sx={[listItemButtonSx, selected == 'todos' ? selectedItem : {}]} onClick={() => selectDrawerItem('todos')}>
						<ListItemIcon sx={listItemIconSx}>
							<Badge badgeContent={_.filter(todos, todo => !todo.complete).length} color="info">
								<AssignmentTurnedInIcon />
							</Badge>
						</ListItemIcon>
						<ListItemText primary="Todo" sx={openSx} />
					</ListItemButton>
					<Box sx={[openSx, {display: selected == 'todos' ? 'initial' : 'none'}]}>
						<TodoList />
					</Box>
				</ListItem>
				<Divider />
				<ListItem disablePadding sx={listItemSx}>
					<ListItemButton sx={[listItemButtonSx, selected == 'filters' ? selectedItem : {}]} onClick={() => selectDrawerItem('filters')}>
						<ListItemIcon sx={listItemIconSx}>
							<Badge badgeContent={filterCount} color="info">
								<FilterAltIcon />
							</Badge>
						</ListItemIcon>
						<ListItemText primary="Filters" sx={openSx} />
					</ListItemButton>
					{selected == 'filters' &&
						<Box sx={[openSx, { p: 2 }]}>
							<Stack direction="column">
								<StudentAutocomplete defaultValue={sessionData.filterStudentIds} onChange={(selected) => sessionData.set('filterStudentIds', _.map(selected, 'id'))} />
								<SubjectAutocomplete defaultValue={sessionData.filterSubjectIds} onChange={(selected) => sessionData.set('filterSubjectIds', _.map(selected, 'id'))} />
								{/* <CourseAutocomplete defaultValue={sessionData.filterCourseIds} onChange={(selected) => sessionData.set('filterCourseIds', _.map(selected, 'id'))} /> */}
								<TermAutocomplete defaultValue={sessionData.filterTermIds} onChange={(selected) => sessionData.set('filterTermIds', _.map(selected, 'id'))} />
								<Stack sx={stackSx}>
									<Typography sx={{pl:1}}>Include Completed</Typography>
									<ToggleButtonGroup value={sessionData.filterStatuses?.length > 0} exclusive onChange={(e) => sessionData.set('filterStatuses', e.target.value == 'true' ? ['Not Started', 'In Progress', 'Skipped'] : [])}>
										<ToggleButton value={true}>Off</ToggleButton>
										<ToggleButton value={false}>On</ToggleButton>
									</ToggleButtonGroup>
								</Stack>
							</Stack>
						</Box>
					}
				</ListItem>
			</List>
		</Drawer>
	);
}